import React from 'react'
import CalendarDay from './CalendarDay'
import { ScheduleTable } from 'ui/schedule'
import { ForEachModel, useModel, useModelKey } from '@morningtrain/react-resources'
import { observer } from 'mobx-react'

function Calendar ({ mode = 'view' }) {
  const scheduleId = useModelKey()
  const scheduleModel = useModel()

  return (
    <ScheduleTable>
      <ForEachModel>
        <CalendarDay scheduleModel={scheduleModel} scheduleId={scheduleId} mode={mode} />
      </ForEachModel>
    </ScheduleTable>
  )
}

export default observer(Calendar)
